import { http } from "shared/api/http";
import { ITenant, ITenantSettings } from "../models";

const apiPath = `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenants`;

export const getTenantById = async (id: string): Promise<ITenant> => {
  const res = await http.get<ITenant>(`${apiPath}/${id}`);
  return res?.data;
};

export const updateTenantSettings = async (
  tenantId: string,
  settings: ITenantSettings
): Promise<ITenant> => {
  const res = await http.put<ITenant>(`${apiPath}/${tenantId}/settings`, settings);
  return res?.data;
};

export const testSharePointConnection = async (
  tenantId: string,
  config: {
    aadClientId: string;
    aadClientSecret: string;
    aadTenantId: string;
    documentDriveId: string;
    graphApiUrl: string;
  }
): Promise<{ success: boolean; message: string }> => {
  const res = await http.post<{ success: boolean; message: string }>(
    `${apiPath}/${tenantId}/settings/sharepoint/test`,
    config
  );
  return res?.data;
};

export const testAnthropicKey = async (
  tenantId: string,
  apiKey: string
): Promise<{ success: boolean; message: string }> => {
  const res = await http.post<{ success: boolean; message: string }>(
    `${apiPath}/${tenantId}/settings/eligibility/test-anthropic-key`,
    { apiKey }
  );
  return res?.data;
};

export const tenantService = {
  getTenantById,
  updateTenantSettings,
  testSharePointConnection,
  testAnthropicKey,
};
